import React from "react";

export const DataLayerContext = React.createContext();
